import React from 'react';
import { ListHorizontal } from 'ui/components';
import { SkeletonText } from 'ui/components/skeleton';
import { waFormat } from 'utilities/common';
import * as Fa from 'react-icons/fa';
import { useSelector } from 'react-redux';

export const InformationRecipient = ({ data }) => {
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['SalesOrder.Show']
  );

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  return (
    <section className="border rounded-2 p-3 pt-2 mb-3">
      <div className="fw-semibold py-2 border-bottom" style={{ fontSize: 13 }}>
        {StateLoading ? (
          <div style={{ width: 250 }}>
            <SkeletonText count={1} />
          </div>
        ) : (
          'Informasi Penerima'
        )}
      </div>
      <div className="row pt-2">
        {StateLoading ? (
          dummy?.map((d, i) => (
            <div className="col-12" key={i}>
              <ListHorizontal
                title={<SkeletonText count={1} />}
                content={<SkeletonText count={1} />}
              />
            </div>
          ))
        ) : (
          <>
            <div className="col-12">
              <ListHorizontal title="Nama" content={data?.recipient_name} />
            </div>
            <div className="col-12">
              <ListHorizontal
                title="Kontak"
                content={
                  <div className="row m-0 justify-content-between align-items-center ">
                    <div className="col-8 p-0">
                      <div className="page-pretitle ">
                        {waFormat(data?.recipient_phone)}
                      </div>
                    </div>
                    <div className="col-4 text-end">
                      <button
                        className="btn btn-success p-2"
                        onClick={() =>
                          window.open(
                            `https://wa.me/${waFormat(data?.recipient_phone)}`,
                              '_blank'
                          )
                        }
                        type="button"
                      >
                        <Fa.FaWhatsapp size="20" />
                      </button>
                    </div>
                  </div>
                }
              />
            </div>
            <div className="col-12">
              <ListHorizontal
                title="Alamat"
                className="border-bottom-0"
                content={
                  <div className="">
                    <div className="title fw-semibold">{data?.recipient_address}</div>
                      <div className="page-pretitle">
                        {`${data?.recipient_region?.village_name}, ${data?.recipient_region?.district_name}, ${data?.recipient_region?.regency_name}, ${data?.recipient_region?.province_name}, ${data?.recipient_region?.postal_code}`}
                      </div>
                  </div>
                }
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
};
